import React from 'react'

import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { authActions } from '@services'

import { bindActionToPromise } from '@helpers'

import { PublicPage } from '@components/layouts'
import { CircularProgress, Grid, Typography } from '@components/ui'

const StyledGrid = styled(Grid)`
  text-align: center;
`

const LoaderWrapper = styled.div`
  margin-bottom: 30px;
`

interface InitializeUserProps {
  fetchUser: AsyncFunction
}

function PureInitializeUser({ fetchUser }: InitializeUserProps) {
  React.useEffect(() => {
    fetchUser()
  }, [fetchUser])

  return (
    <PublicPage hideNavbar>
      <Grid container justifyContent="center" alignItems="center">
        <StyledGrid item>
          <LoaderWrapper>
            <CircularProgress size={50} />
          </LoaderWrapper>
          <Typography size="400-md">
            <FormattedMessage id="pages.initialize.title" defaultMessage="Felhasználó azonosítása folyamatban..." />
          </Typography>
        </StyledGrid>
      </Grid>
    </PublicPage>
  )
}

export const InitializeUser = connect(null, dispatch => ({
  fetchUser: bindActionToPromise(dispatch, authActions.fetchUser.request),
}))(PureInitializeUser)

InitializeUser.displayName = 'InitializeUser'
